import { render, staticRenderFns } from "./RiskAnalysisChart.vue?vue&type=template&id=5d8ddacc&scoped=true"
import script from "./RiskAnalysisChart.vue?vue&type=script&lang=js"
export * from "./RiskAnalysisChart.vue?vue&type=script&lang=js"
import style0 from "./RiskAnalysisChart.vue?vue&type=style&index=0&id=5d8ddacc&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d8ddacc",
  null
  
)

export default component.exports